/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Mebi API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  ChangePasswordDto,
  OtpResponseDto,
  ResetPasswordWithOtpDto,
  SendOtpDto,
  VerifyOtpDto,
} from "../model";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type otpControllerSendOtpResponse200 = {
  data: OtpResponseDto;
  status: 200;
};

export type otpControllerSendOtpResponse400 = {
  data: void;
  status: 400;
};

export type otpControllerSendOtpResponse500 = {
  data: void;
  status: 500;
};

export type otpControllerSendOtpResponseSuccess =
  otpControllerSendOtpResponse200 & {
    headers: Headers;
  };
export type otpControllerSendOtpResponseError = (
  | otpControllerSendOtpResponse400
  | otpControllerSendOtpResponse500
) & {
  headers: Headers;
};

export type otpControllerSendOtpResponse =
  | otpControllerSendOtpResponseSuccess
  | otpControllerSendOtpResponseError;

export const getOtpControllerSendOtpUrl = () => {
  return `/otp/send`;
};

/**
 * @summary Send OTP for phone or email
 */
export const otpControllerSendOtp = async (
  sendOtpDto: SendOtpDto,
  options?: RequestInit,
): Promise<otpControllerSendOtpResponse> => {
  return customInstance<otpControllerSendOtpResponse>(
    getOtpControllerSendOtpUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sendOtpDto),
    },
  );
};

export const getOtpControllerSendOtpMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof otpControllerSendOtp>>,
    TError,
    { data: BodyType<SendOtpDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof otpControllerSendOtp>>,
  TError,
  { data: BodyType<SendOtpDto> },
  TContext
> => {
  const mutationKey = ["otpControllerSendOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof otpControllerSendOtp>>,
    { data: BodyType<SendOtpDto> }
  > = (props) => {
    const { data } = props ?? {};

    return otpControllerSendOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OtpControllerSendOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof otpControllerSendOtp>>
>;
export type OtpControllerSendOtpMutationBody = BodyType<SendOtpDto>;
export type OtpControllerSendOtpMutationError = ErrorType<void>;

/**
 * @summary Send OTP for phone or email
 */
export const useOtpControllerSendOtp = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof otpControllerSendOtp>>,
      TError,
      { data: BodyType<SendOtpDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof otpControllerSendOtp>>,
  TError,
  { data: BodyType<SendOtpDto> },
  TContext
> => {
  return useMutation(
    getOtpControllerSendOtpMutationOptions(options),
    queryClient,
  );
};
export type otpControllerVerifyOtpResponse200 = {
  data: OtpResponseDto;
  status: 200;
};

export type otpControllerVerifyOtpResponse400 = {
  data: void;
  status: 400;
};

export type otpControllerVerifyOtpResponse500 = {
  data: void;
  status: 500;
};

export type otpControllerVerifyOtpResponseSuccess =
  otpControllerVerifyOtpResponse200 & {
    headers: Headers;
  };
export type otpControllerVerifyOtpResponseError = (
  | otpControllerVerifyOtpResponse400
  | otpControllerVerifyOtpResponse500
) & {
  headers: Headers;
};

export type otpControllerVerifyOtpResponse =
  | otpControllerVerifyOtpResponseSuccess
  | otpControllerVerifyOtpResponseError;

export const getOtpControllerVerifyOtpUrl = () => {
  return `/otp/verify`;
};

/**
 * @summary Verify OTP
 */
export const otpControllerVerifyOtp = async (
  verifyOtpDto: VerifyOtpDto,
  options?: RequestInit,
): Promise<otpControllerVerifyOtpResponse> => {
  return customInstance<otpControllerVerifyOtpResponse>(
    getOtpControllerVerifyOtpUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(verifyOtpDto),
    },
  );
};

export const getOtpControllerVerifyOtpMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof otpControllerVerifyOtp>>,
    TError,
    { data: BodyType<VerifyOtpDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof otpControllerVerifyOtp>>,
  TError,
  { data: BodyType<VerifyOtpDto> },
  TContext
> => {
  const mutationKey = ["otpControllerVerifyOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof otpControllerVerifyOtp>>,
    { data: BodyType<VerifyOtpDto> }
  > = (props) => {
    const { data } = props ?? {};

    return otpControllerVerifyOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OtpControllerVerifyOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof otpControllerVerifyOtp>>
>;
export type OtpControllerVerifyOtpMutationBody = BodyType<VerifyOtpDto>;
export type OtpControllerVerifyOtpMutationError = ErrorType<void>;

/**
 * @summary Verify OTP
 */
export const useOtpControllerVerifyOtp = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof otpControllerVerifyOtp>>,
      TError,
      { data: BodyType<VerifyOtpDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof otpControllerVerifyOtp>>,
  TError,
  { data: BodyType<VerifyOtpDto> },
  TContext
> => {
  return useMutation(
    getOtpControllerVerifyOtpMutationOptions(options),
    queryClient,
  );
};
export type otpControllerResetPasswordResponse200 = {
  data: OtpResponseDto;
  status: 200;
};

export type otpControllerResetPasswordResponse400 = {
  data: void;
  status: 400;
};

export type otpControllerResetPasswordResponse404 = {
  data: void;
  status: 404;
};

export type otpControllerResetPasswordResponse500 = {
  data: void;
  status: 500;
};

export type otpControllerResetPasswordResponseSuccess =
  otpControllerResetPasswordResponse200 & {
    headers: Headers;
  };
export type otpControllerResetPasswordResponseError = (
  | otpControllerResetPasswordResponse400
  | otpControllerResetPasswordResponse404
  | otpControllerResetPasswordResponse500
) & {
  headers: Headers;
};

export type otpControllerResetPasswordResponse =
  | otpControllerResetPasswordResponseSuccess
  | otpControllerResetPasswordResponseError;

export const getOtpControllerResetPasswordUrl = () => {
  return `/otp/reset-password`;
};

/**
 * @summary Reset password using OTP
 */
export const otpControllerResetPassword = async (
  resetPasswordWithOtpDto: ResetPasswordWithOtpDto,
  options?: RequestInit,
): Promise<otpControllerResetPasswordResponse> => {
  return customInstance<otpControllerResetPasswordResponse>(
    getOtpControllerResetPasswordUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(resetPasswordWithOtpDto),
    },
  );
};

export const getOtpControllerResetPasswordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof otpControllerResetPassword>>,
    TError,
    { data: BodyType<ResetPasswordWithOtpDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof otpControllerResetPassword>>,
  TError,
  { data: BodyType<ResetPasswordWithOtpDto> },
  TContext
> => {
  const mutationKey = ["otpControllerResetPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof otpControllerResetPassword>>,
    { data: BodyType<ResetPasswordWithOtpDto> }
  > = (props) => {
    const { data } = props ?? {};

    return otpControllerResetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OtpControllerResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof otpControllerResetPassword>>
>;
export type OtpControllerResetPasswordMutationBody =
  BodyType<ResetPasswordWithOtpDto>;
export type OtpControllerResetPasswordMutationError = ErrorType<void>;

/**
 * @summary Reset password using OTP
 */
export const useOtpControllerResetPassword = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof otpControllerResetPassword>>,
      TError,
      { data: BodyType<ResetPasswordWithOtpDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof otpControllerResetPassword>>,
  TError,
  { data: BodyType<ResetPasswordWithOtpDto> },
  TContext
> => {
  return useMutation(
    getOtpControllerResetPasswordMutationOptions(options),
    queryClient,
  );
};
export type otpControllerChangePasswordResponse200 = {
  data: OtpResponseDto;
  status: 200;
};

export type otpControllerChangePasswordResponse400 = {
  data: void;
  status: 400;
};

export type otpControllerChangePasswordResponse401 = {
  data: void;
  status: 401;
};

export type otpControllerChangePasswordResponse500 = {
  data: void;
  status: 500;
};

export type otpControllerChangePasswordResponseSuccess =
  otpControllerChangePasswordResponse200 & {
    headers: Headers;
  };
export type otpControllerChangePasswordResponseError = (
  | otpControllerChangePasswordResponse400
  | otpControllerChangePasswordResponse401
  | otpControllerChangePasswordResponse500
) & {
  headers: Headers;
};

export type otpControllerChangePasswordResponse =
  | otpControllerChangePasswordResponseSuccess
  | otpControllerChangePasswordResponseError;

export const getOtpControllerChangePasswordUrl = () => {
  return `/otp/change-password`;
};

/**
 * @summary Change password for authenticated user
 */
export const otpControllerChangePassword = async (
  changePasswordDto: ChangePasswordDto,
  options?: RequestInit,
): Promise<otpControllerChangePasswordResponse> => {
  return customInstance<otpControllerChangePasswordResponse>(
    getOtpControllerChangePasswordUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(changePasswordDto),
    },
  );
};

export const getOtpControllerChangePasswordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof otpControllerChangePassword>>,
    TError,
    { data: BodyType<ChangePasswordDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof otpControllerChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordDto> },
  TContext
> => {
  const mutationKey = ["otpControllerChangePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof otpControllerChangePassword>>,
    { data: BodyType<ChangePasswordDto> }
  > = (props) => {
    const { data } = props ?? {};

    return otpControllerChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OtpControllerChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof otpControllerChangePassword>>
>;
export type OtpControllerChangePasswordMutationBody =
  BodyType<ChangePasswordDto>;
export type OtpControllerChangePasswordMutationError = ErrorType<void>;

/**
 * @summary Change password for authenticated user
 */
export const useOtpControllerChangePassword = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof otpControllerChangePassword>>,
      TError,
      { data: BodyType<ChangePasswordDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof otpControllerChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordDto> },
  TContext
> => {
  return useMutation(
    getOtpControllerChangePasswordMutationOptions(options),
    queryClient,
  );
};
